// extracted by mini-css-extract-plugin
module.exports = {"login-form":"LoginForm_login-form__KFyFg","submit-button-wrapper":"LoginForm_submit-button-wrapper__Dmprb","submit-button-error":"LoginForm_submit-button-error__3re9m"};